import Hero from "../components/site/Hero";
import Philosophy from "../components/site/Philosophy";
import QuoteBand from "../components/site/QuoteBand";
import Paths from "../components/site/Paths";
import Classes from "../components/site/Classes";
import OnlineLibrary from "../components/site/OnlineLibrary";
import YogaSutras from "../components/site/YogaSutras";
import About from "../components/site/About";
import Newsletter from "../components/site/Newsletter";
import Closing from "../components/site/Closing";
import { usePageMeta } from "../components/site/page";
import { MeditationPopup } from "../components/site/MeditationPopup";

export default function Home() {
  usePageMeta(
    "Jake Ferree · Feeling Moved — Yoga, Breathwork, Massage & Bodywork, Meditation",
    "Jake Ferree — yoga, breathwork, massage & bodywork, meditation and hypnotherapy in San Diego and online. Come back into your body."
  );
  return (
    <div data-testid="homepage">
      <Hero />
      <Philosophy />
      <QuoteBand />
      <Paths />
      <Classes />
      <OnlineLibrary />
      <YogaSutras />
      <About />
      <Newsletter />
      <Closing />
      <MeditationPopup />
    </div>
  );
}
